'use strict';

var DEFAULT_URL_STORAGE_KEY = 'defaultUrl';

/**
 * Retrieves the default URLs from session storage.
 * @returns {Object} data pulled from site key, or blank object
 */
function getDefaultUrls() {
    try {
        return JSON.parse(sessionStorage.getItem(DEFAULT_URL_STORAGE_KEY)) || {};
    } catch (error) {
        return {};
    }
}

module.exports = {
    init: function () {
        $(document).ready(function () {
            var pathname = window.location.pathname;
            var legacyKey = 'defaultUrl_' + pathname;
            var defaultUrls = getDefaultUrls();

            if (!defaultUrls[pathname]) {
                defaultUrls[pathname] = sessionStorage.getItem(legacyKey) || window.location.href;
                sessionStorage.setItem(DEFAULT_URL_STORAGE_KEY, JSON.stringify(defaultUrls));
                sessionStorage.removeItem(legacyKey);
            }

            $('a.popular-cat-link').on('click', function(event) {
                event.preventDefault();

                var currentPath = window.location.pathname;
                var currentDefaultUrls = getDefaultUrls();
                var defaultUrl = currentDefaultUrls[currentPath];
                var clickedUrl = this.href;

                if (clickedUrl === window.location.href && defaultUrl) {
                    window.location.href = defaultUrl;
                } else {
                    window.location.href = clickedUrl;
                }
            });
        });

        $('.plp-category-carousel').on('afterChange', function (event, slick) {
            slick.$slides.removeClass('prev-slide');

            // Find the current active slide element
            var $currentSlide = $(slick.$slides[slick.currentSlide]);

            // Find the immediately preceding sibling and add the custom class
            $currentSlide.prev().addClass('prev-slide');
        });

        $('.plp-category-carousel').on('beforeChange', function (event, slick) {
            slick.$slides.removeClass('prev-slide');
        });
    }
};
